import { DetailModel, FieldModel, ProgramTask } from '@cibo/core'
import { CircularProgress, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { TraitCellContainer } from './TraitCells/TraitCellContainer'
import { TRAIT_DISPLAY_MAP } from './traitDisplayMap'

const formatDetailValue = (detail: DetailModel | undefined): string => {
  if (!detail) return ''
  const raw = detail.result ?? detail.input
  if (raw === null || raw === undefined) return ''
  if (typeof raw === 'boolean') return raw ? 'Yes' : 'No'
  if (typeof raw === 'number' || typeof raw === 'string') return String(raw)
  return JSON.stringify(raw)
}

interface FieldTraitTaskEditorTableCellProps extends GridRenderCellParams {
  row: { fieldModel: FieldModel; [key: string]: any }
  field: string // traitId
  value: DetailModel | undefined
  task: ProgramTask<any>
  onSaveSuccess?: () => void
  isLoading?: boolean
}

export const FieldTraitTaskEditorTableCell = ({
  row: { fieldModel },
  value,
  field: traitId,
  task,
  onSaveSuccess,
  isLoading,
}: FieldTraitTaskEditorTableCellProps) => {
  const Display = TRAIT_DISPLAY_MAP[traitId]

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <TraitCellContainer
        value={value}
        task={task as any}
        selectedField={fieldModel}
        traitId={traitId}
        onSaveSuccess={onSaveSuccess}
      >
        {Display ? (
          <Display value={value} />
        ) : (
          <Typography variant="body2">{formatDetailValue(value)}</Typography>
        )}
      </TraitCellContainer>
      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'action.hover',
          }}
        >
          <CircularProgress size={16} />
        </Box>
      )}
    </Box>
  )
}
